import React from 'react';
import PlpPromotion from './promotion';
import reduxModules from '../common/redux/nextjs-modules';
import { fetchPlpState } from '../common/redux/reducers/index';

function PlpPromotionMaster(props) {
  return (
    <React.Fragment>
      <PlpPromotion {...props} />
    </React.Fragment>
  );
}

PlpPromotionMaster.reduxModules = reduxModules;

PlpPromotionMaster.getInitialProps = async function (context) {
  const promotionCode = context.query.promotionCode;
  await context.store.dispatch(fetchPlpState(promotionCode, 'promotionPLP'));
};

export default PlpPromotionMaster;
